import { useState } from 'libs/react';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { useAlert } from './alert/AlertStack';
import { ModalSendEmail } from './modal/ModalSendEmail';
import { MutationForm } from './form/graphql/MutationForm';
import './SendEmailButton.scss';
/**
 * @component SendEmailButton
 * @since 1.0.0
 * @hidden
 */
export function SendEmailButton(props) {
    const { sendEmailsMutation } = props;
    const [error, setError] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const alert = useAlert();
    /**
     * @function onPressOpenModal
     * @since 1.0.0
     */
    const onPressOpenModal = () => {
        setOpenModal(true);
    };
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    const onClose = () => {
        setOpenModal(false);
    };
    /**
     * @function onModalSubmit
     * @since 1.0.0
     * @hidden
     */
    const onModalSubmit = () => {
        setOpenModal(false);
        return {};
    };
    /**
     * @function onSuccess
     * @since 1.0.0
     * @hidden
     */
    const onSuccess = () => {
        alert.present({
            title: (React.createElement("p", null, t('The email was sent with success to your organizations.')))
        });
    };
    /**
     * @function onFailure
     * @since 1.0.0
     * @hidden
     */
    const onFailure = (error) => {
        setError(error);
        alert.present({ error });
    };
    return (React.createElement("div", null,
        React.createElement("button", { className: "send-email-button", onClick: onPressOpenModal },
            React.createElement(Icon, { className: "send-email-button-picto", value: "paper-plane" }),
            React.createElement(Text, { className: "send-email-button-label", value: t('Send Email') })),
        openModal && (React.createElement(MutationForm, { name: "send-emails-form", mutation: sendEmailsMutation, onProcess: onModalSubmit, onSuccess: onSuccess, onFailure: onFailure },
            React.createElement(ModalSendEmail, { onClose: onClose })))));
}
